import type { CSSProperties, ReactNode } from "react";
import React from "react";

import "./kit.css";

export type T_SurfacePadding = "compact" | "none" | "regular";
export type T_SurfaceShape = "card" | "pill";
export type T_SurfaceTone = "accent" | "neutral" | "raised" | "subtle";

export type T_SurfaceProps = {
  children: ReactNode;
  padding?: T_SurfacePadding;
  shape?: T_SurfaceShape;
  style?: CSSProperties;
  tone?: T_SurfaceTone;
};

function getSurfaceColor(tone: T_SurfaceTone): string {
  switch (tone) {
    case "accent":
      return "var(--lattice-chatkit-purple-tint-bg)";
    case "neutral":
      return "var(--lattice-dark-grey-dark-6)";
    case "raised":
      return "var(--lattice-dark-grey-dark-4)";
    case "subtle":
      return "var(--lattice-dark-grey-dark-7)";
  }
}

/**
 * Canonical non-interactive container — web mirror of the mobile Surface.
 * Separation comes from fill and space, never borders.
 */
export function Surface({
  children,
  padding = "regular",
  shape = "card",
  style,
  tone = "neutral",
}: T_SurfaceProps) {
  return (
    <div
      className={[
        "lk-surface",
        shape === "pill" ? "lk-surface--pill" : "lk-surface--card",
        padding === "regular" ? "lk-surface--padding-regular" : "",
        padding === "compact" ? "lk-surface--padding-compact" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{ backgroundColor: getSurfaceColor(tone), ...style }}
    >
      {children}
    </div>
  );
}
